import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'
import { mapItemPolicyCalculatedCreditsResponse } from 'businessTraveller/api/mappers/itemPolicyMappers'
import { logDatadog } from 'services/datadogRum'

type ItemPolicyCalculatedCreditsRequestWire = paths['/api/business-traveller/businesses/{businessId}/item-policies/calculate']['post']['requestBody']['content']['application/json']
type ItemPolicyCalculatedCreditsServerResponseWire = paths['/api/business-traveller/businesses/{businessId}/item-policies/calculate']['post']['responses'][200]['content']['application/json']

enum ITEM_POLICY_CALCULATED_CREDITS_ERRORS {
  NO_CALCULATION = 'Could not calculate item policies!',
  OTHER = 'Something went wrong!',
}

interface Params {
  businessId: string
}

async function requestPostItemPoliciesCalculatedCredits(
  params: Params,
  payload: ItemPolicyCalculatedCreditsRequestWire,
): Promise<Record<string, App.BusinessTraveller.ItemPolicyCalculatedCreditsResult>> {
  const { businessId } = params
  let response: ItemPolicyCalculatedCreditsServerResponseWire

  try {
    response = await requestUtils.post<
      ItemPolicyCalculatedCreditsServerResponseWire,
      ItemPolicyCalculatedCreditsRequestWire
    >(
      `/api/business-traveller/businesses/${businessId}/item-policies/calculate`,
      payload,
      { credentials: 'include' },
    )
  } catch(err) {
    logDatadog('lebt.item_policy.calculated_credits.request_failed', {
      businessId,
      employeeCount: payload.employeeIds.length,
      itemCount: payload.items.length,
      err,
    }, 'error')
    throw new Error(ITEM_POLICY_CALCULATED_CREDITS_ERRORS.OTHER, { cause: err })
  }

  if (!response.result) {
    throw new Error(ITEM_POLICY_CALCULATED_CREDITS_ERRORS.NO_CALCULATION)
  }

  return mapItemPolicyCalculatedCreditsResponse(response.result)
}

export default requestPostItemPoliciesCalculatedCredits
